/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useMemo} from 'react'
import { MenuComponent } from '../../../../../../_metronic/assets/ts/components'
import { KTSVG } from '../../../../../../_metronic/helpers'
import { DLMSiteApplication, DLM_APPLICANT_INSPECTION_RESPOND_STATES, DLM_END_STATES, DLM_NO_TERMINATE_STATES } from '../../../../core/doclabel'
import { useDLMLabellingListContext } from '../../../../core/doclabel/components/labelling-list/components'
import { useAuth } from '../../../../auth'
type Props = {
  site: DLMSiteApplication 
}

const DLMLabellingApplicantActionsCell: FC<Props> = ({site}) => {
    
    const { setCurrentSite, setItemIDForDelete, setItemIDForUpdate, applicationOwnerId } = useDLMLabellingListContext();
    const { currentUser } = useAuth();
   
    const { canRespond, responseTitle, canTerminate, canTerminateCancel, canTerminateReply } = useMemo(() => {

        if (! site) return { canRespond : false, responseTitle: '', canTerminate: false, canTerminateCancel: false, canTerminateReply: false};
        let responseTitle = "Respond";
        
        const { state, requestTerminateState } = site;
        const canRespond = (state && DLM_APPLICANT_INSPECTION_RESPOND_STATES.indexOf(site.state) > -1);

        const canTerminate = (
            (! DLM_END_STATES.includes(state)) 
            && (! DLM_NO_TERMINATE_STATES.includes(state))
            && (! (requestTerminateState && (requestTerminateState === 'REQUEST_TERMINATE_APPLICATION' || requestTerminateState === 'REQUEST_TERMINATE_APPLICATION_REPLY')))
            && (currentUser && (
                currentUser.role === 'Management' || applicationOwnerId === currentUser.id
            ))
        );

        const canTerminateCancel: boolean = (            
          (requestTerminateState !== undefined) && 
          (requestTerminateState === 'REQUEST_TERMINATE_APPLICATION' || requestTerminateState === 'REQUEST_TERMINATE_APPLICATION_REPLY')                
        );

        const canTerminateReply = (requestTerminateState && requestTerminateState === 'REQUEST_TERMINATE_APPLICATION_REPLY') ? true : false;

        switch (state) {
            case 'Pending Site Labelling':
                responseTitle = 'Arrange Site Labelling';
                break;
            case 'Applicant Sign':
                responseTitle = 'Sign ROI';
                break;
            default: 
                break;
        }
        
        return { canRespond, responseTitle, canTerminate, canTerminateCancel, canTerminateReply };
    }, [site, applicationOwnerId, currentUser]);

    useEffect(() => {
        if (canRespond || canTerminate || canTerminateCancel || canTerminateReply) {
            MenuComponent.reinitialization()
        }
    }, [canRespond, canTerminate, canTerminateCancel, canTerminateReply])

    
    if (! (canRespond || canTerminate || canTerminateCancel || canTerminateReply)) {
        return null;
    }
    
    return (
    <div className="align-top">
    <div        
        className='btn btn-light btn-active-light-primary btn-sm'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-start'
    >
        Actions
        <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-5 m-0' />
    </div>
      
    <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 py-4 mw-125px'
        data-kt-menu='true'
    >        
        { canRespond && 
        <div className='menu-item px-3'>
            <a className='menu-link px-3' onClick={() => { setCurrentSite(site) }}>
                {responseTitle}
            </a>
        </div>         
        }
        { canTerminate && 
        <div className='menu-item px-3 text-start' title="Terminate Labelling">
            <a className='menu-link px-3 text-hover-danger' onClick={() => setItemIDForDelete(site.id)}>
                Terminate
            </a>
        </div> 
        }
        { canTerminateCancel && 
        <div className='menu-item px-3 text-start' title="Cancel Terminate Labelling">
            <a className='menu-link px-3 text-hover-danger' onClick={() => setItemIDForDelete(site.id)}>
                Cancel Terminate
            </a>
        </div> 
        }
        { canTerminateReply && 
        <div className='menu-item px-3 text-start' title="Respond to Termination RFI">
            <a className='menu-link px-3 text-hover-danger' onClick={() => setItemIDForUpdate(site.id)}>
              Respond to Termination RFI
            </a>
        </div> 
        }
    </div>    
    </div>
  )
}

export {DLMLabellingApplicantActionsCell}
